import { Button } from "react-aria-components"
import { modalSignal } from "./ModalContainer"
import infoIcon from "../../../assets/icons/icon-information.svg"

interface IUnsavedChangesModal {
    onDiscard: () => void,
    onSave: () => Promise<void>,
    onCancel?: () => void
}

export default function UnsavedChangesModal({ onDiscard, onSave, onCancel }: IUnsavedChangesModal) {
    async function handleSave() {
        await onSave();
        modalSignal.value = undefined;
    }

    function handleDiscard() {
        modalSignal.value = undefined;
        onDiscard();
    }

    function handleCancel() {
        modalSignal.value = undefined;
        if (onCancel) {
            onCancel();
        }
    }

    return (
        <div className="display--flex flex__direction--column alignItems--center gap--xs">
            <img src={infoIcon} />
            <h1>You have unsaved changes</h1>
            <p className="textAlign--center whitespace--pre-line textWrap">
                You have unsaved changes. What would you like to do?
            </p>
            <div className="margin__top--xs display--flex gap--xs">
                <Button className=" button button--large button--secondary button--with-icon" onPress={handleCancel}>
                    <p className="button-text">Back</p>
                </Button>
                <Button className=" button button--large button--secondary button--with-icon" onPress={handleDiscard}>
                    <p className="button-text">Discard Changes</p>
                </Button>
                <Button className=" button button--large button--primary button--with-icon" onPress={handleSave}>
                    <p className="button-text">Save Changes</p>
                </Button>
            </div>
        </div>
    )
}
